<template>
  <div
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit" ref="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">สร้างโปรไฟล์ตัวแทนฯย่อย</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label class="label-required">ตัวแทนฯย่อย:</label>
                      <select
                        id="customerCode"
                        name="customerCode"
                        ref="customerCode"
                        class="form-control m-select2"
                        style="width: 100%;"
                      ></select>
                      <span class="form-text"></span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    ระบบจะสร้างโปรไฟล์ตัวแทนฯย่อยให้ทั้งหมด 1 รายการ ดังนี้
                    <br />1) ชื่อตัวแทนฯย่อย (พนักงาน)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> สร้างโปรไฟล์
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  methods: {
    formSubmit: function(e) {
      e.preventDefault();

      let self = this;
      if (
        !$(self.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      axios
        .post("/Api/CompanyProfile/CreateSubDefault", {
          customerCode: $(self.$refs.customerCode).val()
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                $(self.$el).modal("hide");
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    }
  },
  mounted() {
    let self = this;

    $(self.$refs.form).validate({
      rules: {
        customerCode: "required"
      },
      messages: {
        customerCode: "กรุณาเลือกตัวแทนฯย่อย"
      }
    });

    $(self.$el).on("hidden.bs.modal", function() {
      $(self.$refs.customerCode)
        .val("")
        .trigger("change");
    });

    $(self.$refs.customerCode).select2({
      placeholder: "กรุณาเลือกตัวแทนฯย่อย",
      allowClear: true,
      ajax: {
        url: "/Api/Shop/Select2Shop",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            onlySubAgent: true
          };
          return JSON.stringify(query);
        },
        processResults: function(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function(params, success, failure) {
          params.beforeSend = function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    });
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/User/SubAgentProfileCreateForm.vue